export default __webpack_public_path__ + "static/media/avatar.f5301288.jpg";